import React from 'react';
import styles from './MerchantSample.module.css';
import MerchantSample from './MerchantSample';

const MerchantSuggestions = () => {
    return (
        <div className={styles.suggestions}>
            <MerchantSample  index='restaurants'/>
            <MerchantSample  index='activity'/>
            <MerchantSample  index='beauty'/>
            <MerchantSample  index='cars'/>
            <MerchantSample  index='alimentation'/>
        </div>
    );
};

export default MerchantSuggestions;
